import { CarePack, CustomService, DEFAULT_LOC, Deploy, DISABLE_LOC, DUMMY_DATE, FACTORY_SERVICES, HIDE_LABELS, LOC_AVAILABILITY,LOC_CHOICE_ID, LOC_MAPPING, MandA, MATERIAL_AVAILABILITY, MODEL_AVAILABILITY_TABLE, OCPLC_ADMIN, OCPLC_READ_ONLY, OCPLC_REGIONAL, PLC_ADMIN, PLC_WW, PM, REGION_WW, REGIONS, ROLE_NAME_FOR_ADMIN, ROLE_NAME_FOR_KE, ROLE_NAME_FOR_KE_AP, ROLE_NAME_FOR_KE_EU, ROLE_NAME_FOR_KE_LA, ROLE_NAME_FOR_KE_NA, TOF_PROGRAM_MANAGEMENT, VERSION_0002, VERSION_0003 } from "constants/ocplcConstants";
import dayjs from "dayjs";
import { TABLE_TYPES } from "pages/OcplcEditDashboard/TableDataConfig";
import { getFromLocalStorage, LOCAL_STORAGE_KEY } from "utils/localStorageUtil";

export const getDateRange = (date, wwDate) =>
  date?.toString().startsWith(DUMMY_DATE) && wwDate !== DUMMY_DATE
    ? wwDate
    : date;

export const findSelectedRole = (roles, roleId) => {
  return roles.find((role) => role.id === roleId) || null;
};

export function capitalizeFirstLetter(val) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

export const getPlcRoles = (roles) => {
  return roles?.filter(role => role?.id.startsWith('plc')) || [];
};

export const isPLCAdmin = (userRole) => userRole === ROLE_NAME_FOR_ADMIN || userRole === PLC_ADMIN;

export const isPLCWW = (userRole) => userRole === PLC_WW;

export const isOcplcEditPage = (pathname) =>
  /\/ocplc\/(edit|viewRecord|parameters|localization)/.test(pathname);


export const isUserDisabled = (userRole, selectedTable = "") => {
  const isRegionalRole = userRole === OCPLC_REGIONAL;
  const isReadOnlyRole = userRole === OCPLC_READ_ONLY;
  const isNotFactoryServiceTable = selectedTable !== FACTORY_SERVICES;
  return isReadOnlyRole || (isNotFactoryServiceTable && isRegionalRole);
};

export const getVersion = (type) => {
  if (type === 'edit') return VERSION_0002;
  else if (type === 'viewRecord') return VERSION_0003;
  else return null;
};

export const filterDetails = (details, selectKmat, version,selectedTable) => {
  return details.filter((detail) =>
    !((HIDE_LABELS.includes(detail.label) && selectKmat === '') || ((detail.label==="Status")&&[TABLE_TYPES.MATERIAL,TABLE_TYPES.FACTORY].includes(selectedTable) && selectKmat === "ALL") ||
      (detail.label === "Status" && version === VERSION_0003))
  );
};

export const toLowerCaseRegion = (region) => region.toLowerCase();

export const updateCountryData = (updatedData, field, value, countryList, setIsCheckboxDisabled, selectedTable) => {
  if (field === 'countryID') {
    const selectedCountry = countryList.find(country => country.countryCode === value);

    if (selectedCountry) {
      updatedData['countryDesc'] = selectedCountry.countryName;
      if (selectedTable !== LOC_AVAILABILITY) {

      REGIONS.forEach(region => { updatedData[toLowerCaseRegion(region)] = false });
      const selectedRegion = selectedCountry.regionCode;

      if (Array.isArray(selectedRegion)) {
        setIsCheckboxDisabled(false);
        selectedRegion.forEach(region => { updatedData[toLowerCaseRegion(region)] = true });
      } else if (selectedRegion) {
        setIsCheckboxDisabled(true);
        updatedData[toLowerCaseRegion(selectedRegion)] = true;
      }
    }
  }
}
  return updatedData;
};

export const isCompleteDisabled = (userRole, region, assignedRole, checkedRows, selectedTable, version) => {
  const isRegionWW = region === REGION_WW;
  const isAdminRole = assignedRole === ROLE_NAME_FOR_ADMIN;
  const isKERole = assignedRole === ROLE_NAME_FOR_KE;
  const isKEAPRole = assignedRole === ROLE_NAME_FOR_KE_AP;
  const isKEEURole = assignedRole === ROLE_NAME_FOR_KE_EU;
  const isKELARole = assignedRole === ROLE_NAME_FOR_KE_LA;
  const isKENARole = assignedRole === ROLE_NAME_FOR_KE_NA;
  const isKEGroup = isKELARole || isKEAPRole || isKEEURole || isKENARole;
  const isRegionalRole = assignedRole === OCPLC_REGIONAL;
  const isReadOnlyRole = assignedRole === OCPLC_READ_ONLY;
  const hasSelectedRows = checkedRows.length === 0;
  const hasWWforSelectedRows = checkedRows.some(row => row.region === REGION_WW);
  const isLogicalLockForBulk = checkedRows.some(row => row.logicalLock !== 0);
  const isVersionRestricted = version === VERSION_0003;
 
  switch (selectedTable) {
    case TOF_PROGRAM_MANAGEMENT:
    case LOC_CHOICE_ID:
    case LOC_MAPPING:
      return isVersionRestricted || hasSelectedRows || !(isAdminRole || isKERole);
 
    case LOC_AVAILABILITY:
      return isVersionRestricted || hasSelectedRows || (!isAdminRole && !isKERole);
 
    case DEFAULT_LOC:
      return isVersionRestricted || hasSelectedRows || !(isAdminRole || isKEGroup);

    case FACTORY_SERVICES:
       return isVersionRestricted || hasSelectedRows || (!isAdminRole && !isRegionalRole);
 
    case MATERIAL_AVAILABILITY:
      switch (true) {
        case isAdminRole:
          return isLogicalLockForBulk;
        case isKERole:
          return isLogicalLockForBulk || !isRegionWW;
        case isKEGroup:
          return isLogicalLockForBulk || isRegionWW;
        case isReadOnlyRole:
        case isRegionalRole:
          return true;
        default:
          return false;
      }
 
    default:
      if (isKERole) return !isRegionWW || hasSelectedRows;
      if (isKEGroup) return hasWWforSelectedRows || hasSelectedRows;
      if (isRegionalRole) return selectedTable !== FACTORY_SERVICES || hasSelectedRows;
      return (
        !isAdminRole &&
        (isPLCWW(userRole) || isRegionWW || isRegionalRole || isReadOnlyRole) ||
        hasSelectedRows
      );
  }
};
 


export const isCopyDisabled = (version, assignedRole, region, checkedRow, selectedTable) => {
  const isVersionRestricted = version === VERSION_0003;
  const isRegionalRole = [ROLE_NAME_FOR_KE_AP, ROLE_NAME_FOR_KE_EU, ROLE_NAME_FOR_KE_LA, ROLE_NAME_FOR_KE_NA].includes(assignedRole);
  const isRegionalRolewithWW = isRegionalRole && region === REGION_WW;
  const isKERoleOutsideWW = assignedRole === ROLE_NAME_FOR_KE && region !== REGION_WW;
  const isAdminOrKEOrOtherReg = [ROLE_NAME_FOR_ADMIN, ROLE_NAME_FOR_KE,ROLE_NAME_FOR_KE_AP, ROLE_NAME_FOR_KE_EU, ROLE_NAME_FOR_KE_LA, ROLE_NAME_FOR_KE_NA].includes(assignedRole);
  const isNonAdminNonKERoleRestricted = assignedRole !== ROLE_NAME_FOR_KE && assignedRole !== ROLE_NAME_FOR_ADMIN && [OCPLC_READ_ONLY, OCPLC_REGIONAL].includes(assignedRole);
  const isAdminRegional = [ROLE_NAME_FOR_ADMIN, ROLE_NAME_FOR_KE_AP, ROLE_NAME_FOR_KE_EU, ROLE_NAME_FOR_KE_LA, ROLE_NAME_FOR_KE_NA].includes(assignedRole);
  const isInvalidRowSelection = checkedRow.length !== 1;
  const isWWRowSelected = checkedRow[0]?.region !== "WW";
  const isCountryBusinessAll = checkedRow[0]?.country !== 'ALL' && checkedRow[0]?.businessModel !== 'ALL';
  const isAdminOrRegional = [ROLE_NAME_FOR_ADMIN, OCPLC_REGIONAL].includes(assignedRole);
  const isAdminOrKE = [ROLE_NAME_FOR_ADMIN, ROLE_NAME_FOR_KE].includes(assignedRole);
  const isInvalidComments = checkedRow[0]?.comments === DISABLE_LOC;
  
  if (selectedTable === FACTORY_SERVICES && !isVersionRestricted) {
    return !(isAdminOrRegional && !isInvalidRowSelection && !isCountryBusinessAll);
  }
  if (selectedTable === LOC_AVAILABILITY && !isVersionRestricted) {
    return !(isAdminOrKE && !isInvalidRowSelection && !isInvalidComments);
  }
  if (selectedTable === DEFAULT_LOC && !isVersionRestricted) {
    return !(isAdminRegional && !isInvalidRowSelection);
  }
  if (selectedTable === MATERIAL_AVAILABILITY && !isVersionRestricted && !isWWRowSelected && !isRegionalRolewithWW && !isKERoleOutsideWW) {
    return !(isAdminOrKEOrOtherReg && !isInvalidRowSelection && !isCountryBusinessAll);
  }
  if (selectedTable === TOF_PROGRAM_MANAGEMENT && !isVersionRestricted) {
    if(isVersionRestricted) return true;
    return !(isAdminOrKE && !isInvalidRowSelection)
  }
  if (selectedTable === LOC_CHOICE_ID && !isVersionRestricted) {
    return !(isAdminOrKE && !isInvalidRowSelection);
  }
  if (selectedTable === LOC_MAPPING && !isVersionRestricted) {
    return !(isAdminOrKE && !isInvalidRowSelection);
  }
  return (isVersionRestricted || isRegionalRolewithWW || isKERoleOutsideWW || isNonAdminNonKERoleRestricted || isInvalidRowSelection || isWWRowSelected || isCountryBusinessAll);
};

export const isDeleteDisabled = (version, assignedRole, region, checkedRow, selectedTable,userEmail) => {
  const isParentRecord = checkedRow[0]?.country === "ALL" && checkedRow[0]?.region === "WW" && checkedRow[0].businessModel === "ALL";
  const isVersionRestricted = version === VERSION_0003;
  const isKEGroup = [ROLE_NAME_FOR_KE_AP, ROLE_NAME_FOR_KE_EU, ROLE_NAME_FOR_KE_LA, ROLE_NAME_FOR_KE_NA].includes(assignedRole);
  const isRegionalRolewithWW = isKEGroup && region === REGION_WW;
  const isKERoleOutsideWW = assignedRole === ROLE_NAME_FOR_KE && region !== REGION_WW;
  const isNonAdminNonKERoleRestricted = assignedRole !== ROLE_NAME_FOR_KE && assignedRole !== ROLE_NAME_FOR_ADMIN && [OCPLC_READ_ONLY, OCPLC_REGIONAL].includes(assignedRole);
  const noRowSelected = checkedRow.length !== 1;
  const isOtherRegionSelected = region !== REGION_WW
  const isAdminOrRegional = [ROLE_NAME_FOR_ADMIN, OCPLC_REGIONAL].includes(assignedRole);
  const isAdmin=assignedRole === OCPLC_ADMIN
  const isOCPLCKE = assignedRole === ROLE_NAME_FOR_KE
  const isLogicalLock = checkedRow[0]?.logicalLock !== 0;
  const isAdminRoleWithOtherReg = (assignedRole === ROLE_NAME_FOR_ADMIN || isKEGroup) && isOtherRegionSelected && checkedRow[0]?.region === REGION_WW;
  const isWWRowSelected = checkedRow[0]?.region === "WW";
  const authenticatedUser  = checkedRow[0]?.whoChanged === userEmail;
  if (selectedTable === FACTORY_SERVICES && !isVersionRestricted && !isParentRecord) {
      return !(isAdminOrRegional && !noRowSelected);
    }
  if (selectedTable === MATERIAL_AVAILABILITY && !isVersionRestricted && !isParentRecord && !isWWRowSelected && !isRegionalRolewithWW && !isKERoleOutsideWW) {
      if (isLogicalLock ||(isKEGroup && isWWRowSelected)) {
        return true;
      }
      return !((isAdmin || isOCPLCKE || isKEGroup) && !noRowSelected);
    }
  if(selectedTable === LOC_AVAILABILITY){
    if(isVersionRestricted) return true;
    return !((isAdmin || isOCPLCKE) && !noRowSelected);
  }
  if(selectedTable === DEFAULT_LOC){
    if(isVersionRestricted) return true;
    return !((isAdmin || isKEGroup) && !noRowSelected);
  }
  if(selectedTable === TOF_PROGRAM_MANAGEMENT ||selectedTable === LOC_MAPPING || selectedTable === LOC_CHOICE_ID){
    if(isVersionRestricted) return true;
    return !((isAdmin || isOCPLCKE) && !noRowSelected);
  }
  return (isVersionRestricted || isRegionalRolewithWW || isKERoleOutsideWW || isNonAdminNonKERoleRestricted || noRowSelected || isAdminRoleWithOtherReg || isParentRecord );
};

export const isAddDisabled = (version, assignedRole, region, kmatId, selectedTable) => {
  const isWWRegion = region === REGION_WW;
  const isVersionRestricted = version !== VERSION_0002;
  const isAdminOrKE = [ROLE_NAME_FOR_ADMIN, ROLE_NAME_FOR_KE].includes(assignedRole);
  const isAdminOrRegional = [ROLE_NAME_FOR_ADMIN, OCPLC_REGIONAL].includes(assignedRole);
  const isAdminOrRegionalOther = [ROLE_NAME_FOR_ADMIN, ROLE_NAME_FOR_KE_AP, ROLE_NAME_FOR_KE_EU, ROLE_NAME_FOR_KE_LA, ROLE_NAME_FOR_KE_NA].includes(assignedRole);
 
  if (selectedTable === DEFAULT_LOC && isVersionRestricted) return true;
  if (selectedTable === LOC_AVAILABILITY) return true;
 
  if (isVersionRestricted) return true;
 
  switch (selectedTable) {
    case MATERIAL_AVAILABILITY:
      return !(isAdminOrKE && isWWRegion);
    case FACTORY_SERVICES:
      return !(isAdminOrRegional && isWWRegion);
    case MODEL_AVAILABILITY_TABLE:
      return !(isAdminOrKE && isWWRegion && !kmatId);
    case DEFAULT_LOC:
      return !(isAdminOrRegionalOther && !isWWRegion);
    case TOF_PROGRAM_MANAGEMENT:
      return !(isAdminOrKE && !isWWRegion);
    case LOC_MAPPING:
      return !(isAdminOrKE && isWWRegion);
    case LOC_CHOICE_ID:
      return !(isAdminOrKE && isWWRegion);
    default:
      return false;
  }
};

export function canTransportData(items) {
  const hasRestrictedStatus = items.some(item => item.status !== "Completed" );

  if (hasRestrictedStatus) {
    return {
      isValid: true,
      message: "Data transport is allowed only for KMATs with a 'Completed' status. Please update the status to proceed."
    };
  }
  return { isValid: false, message: "" };
}

export const hasRestrictedStatus = (rows, restrictedStatuses) => {
  return rows.some(row => restrictedStatuses.includes(row.status));
};

export const handleUnauthorizedAccess = (userEmail, author, setDialogState, status, filterKmats, kmatId,assignedRole) => {
  const kmat = filterKmats?.[kmatId];
  const dashboardStatus = ["Published", "New"];
  const latestRowData = getFromLocalStorage(LOCAL_STORAGE_KEY) || {};
  const isLatestRowMatch = Object.keys(latestRowData).length > 0 &&  latestRowData.kmatId === kmatId;
  const isPublishedOrNew = (isLatestRowMatch && dashboardStatus.includes(latestRowData.status)) || dashboardStatus.includes(kmat?.status);

  if (isPublishedOrNew) return false;

  const isMStatus = status === "M";
  const isPStatus = status === "P";
  const isOwner = userEmail === author;
  const isHpAuthor = /^[^@]+@hp\.com$/i.test(author);
  const mStatusAccess = isMStatus && (isOwner || !isHpAuthor);
  const pStatusAccess = isPStatus && (isOwner || !isHpAuthor);
  const isRestrictedStatus = isMStatus || isPStatus;
  const isAuthorized = mStatusAccess || pStatusAccess;
  const isOCPLCAdmin = isPLCAdmin(assignedRole) && isPStatus;
  
  if ( isOCPLCAdmin || (!isRestrictedStatus || isAuthorized)) return false;
  setDialogState({
    open: true,
    message: `Edited record is already accessed and saved by ${author}`
  });
  return true;
};

export const formatDate = (date) => date ? dayjs(date).format('DD/MM/YYYY') : '';

export const formatDateFieldForAudit = (field, row) => {
  const dateFields = {
    startDate: 'DD/MM/YYYY',
    endDate: 'DD/MM/YYYY',
    createDate: 'DD/MM/YYYY HH:mm:ss',
    lastModifiedDate: 'DD/MM/YYYY HH:mm:ss',
    actionDt: 'DD/MM/YYYY HH:mm:ss'
  };

  if (dateFields[field] && row[field]) {
    return dayjs(row[field]).format(dateFields[field]);
  }

  return row[field];
};

   // Helper function for extracting and joining values
   export function extractAndJoin(arr, key) {
       return arr.map(row => row[key]).join(',');
   }

   export const moduleTypeMap = {
    [MATERIAL_AVAILABILITY]: 'MaterialAvailability',
    [FACTORY_SERVICES]: 'ServiceAvailability',
    [MODEL_AVAILABILITY_TABLE]: 'ModelAvailability',
    [DEFAULT_LOC]: 'DefLocalization',
    [LOC_AVAILABILITY]: 'Localization',
    [TOF_PROGRAM_MANAGEMENT]:'Parameters',
    [LOC_MAPPING]:'Parameters',
    [LOC_CHOICE_ID]:'Parameters',
};

export const tableDTMap = {
    [MODEL_AVAILABILITY_TABLE] : "MODEL_DT",
    [MATERIAL_AVAILABILITY]: "MATERIAL_DT",
    [FACTORY_SERVICES]: "SERVICE_DT",
    [LOC_AVAILABILITY]: "AVAILABLE_DT",
    [DEFAULT_LOC]: "DEFAULT_LOC_DT",
    [TOF_PROGRAM_MANAGEMENT]: "PARAMETERS_DT",
    [LOC_MAPPING]: "PARAMETERS_DT",
    [LOC_CHOICE_ID]: "PARAMETERS_DT",
};

export const PARAMETER_TABLES = [
    'TOF Program Management',
    'Localization Mapping',
    'Localization Choice ID Customization',
    'OCPLC Configuration'
];

export const LOCALIZATION_TABLES = [
    'Available Localization',
    'Default Localization'
];

export const isRegionalLockDisabled = ( role, region, choiceId, isLogicalLock, selectedTableRegion) => {
  const isNoChoice = choiceId?.startsWith("NOCHOICE");
  const isAdmin = role === OCPLC_ADMIN;
  const isOCPLCKE = role===ROLE_NAME_FOR_KE
  const isRegionWW = region === 'WW';
  const isSelectedTableRegion = selectedTableRegion !== "WW";

  return isNoChoice || !(isAdmin || isOCPLCKE&&isRegionWW) || isLogicalLock || isSelectedTableRegion;
};
export const CATEGORY_TYPES={
  ["PM"]:"Hardware (PM)",
  ["CarePack"]:"Care pack Services",
  ["CustomService"]:"Configuration Services",
  ["MandA"]:"Monitor and Accessories",
  ["Deploy"]:"Deployment Services"
}

export const isisDTdisable = (assignedRole,checkedRows,selectedTable,version)=>{
  const isAdminRole = assignedRole === ROLE_NAME_FOR_ADMIN;
  const hasSelectedRows = checkedRows.length === 0;
  const isLogicalLock = checkedRows[0]?.logicalLock !== 0 && selectedTable === MATERIAL_AVAILABILITY;
  const isVersionRestricted = version === VERSION_0003;
  const isLogicalLockForBulk = checkedRows.some(row => row.logicalLock !== 0);

  if ([TOF_PROGRAM_MANAGEMENT, LOC_CHOICE_ID, LOC_MAPPING, LOC_AVAILABILITY, DEFAULT_LOC].includes(selectedTable)) {
    return isVersionRestricted || hasSelectedRows || !isAdminRole;
  }

  if (selectedTable === MATERIAL_AVAILABILITY) {
      return !isAdminRole || isVersionRestricted || isLogicalLockForBulk;
  }

  return !isAdminRole || hasSelectedRows || isLogicalLock;

}

export const getFilteredRegions = (regionDropdown=[], selectedTable) => {
  const isServiceAvailability = selectedTable === FACTORY_SERVICES;
  const isDefaultLOC = selectedTable === DEFAULT_LOC;
  const isTOFProgramManagement = selectedTable === TOF_PROGRAM_MANAGEMENT;
  const isLocalizationChoiceId = selectedTable === LOC_CHOICE_ID;
  const isLocalizationMapping = selectedTable === LOC_MAPPING;

  if (isServiceAvailability || isLocalizationChoiceId || isLocalizationMapping) {
    return regionDropdown.filter(region => region.code === 'WW');
  }
  if (isDefaultLOC || isTOFProgramManagement) {
    return regionDropdown.filter(region => region.code !== 'WW');
  }
  return regionDropdown;
};
